import { CustomTable } from "@/components/Tables/CustomTable"
import { columns } from "@/pages/payment-methods/Columns"
import { useCustomQuery } from "@/hooks/useCustomQuery"
import AddContactModal from "./Model"
import { CrudProvider, useCrudContext } from "@/context/crudContext"

export default function PaymentStatusList() {
  const breadcrumbs = [
    { label: "Dashboard", url: "/pos/dashboard" },
    { label: "Payment Status" },
  ]
  return (
    <>
      {/* Breadcrumb */}
      <div className="breadcrumb-card">
        <h5>Payment Status</h5>
      </div>

      <CrudProvider>
        <PaymentStatusTable />
      </CrudProvider>
    </>
  )
}

function PaymentStatusTable() {
  const { openDialog } = useCrudContext()

  return (
    <>
      <CustomTable
        label="Payment Status"
        columns={columns}
        apiPath="settings"
        hardcodedFilters={{ key: "payment-status" }}
        revalidateQuery="payment-status"
      />

      {openDialog ? <AddContactModal routeKey="payment-status" /> : null}
    </>
  )
}
